import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const ReportIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.46667 12.5714H8.53333C9.12 12.5714 9.6 12.0571 9.6 11.4286V1.14286C9.6 0.514286 9.12 0 8.53333 0H7.46667C6.88 0 6.4 0.514286 6.4 1.14286V11.4286C6.4 12.0571 6.88 12.5714 7.46667 12.5714ZM12.8 12.5714H13.8667C14.4533 12.5714 14.9333 12.0571 14.9333 11.4286V4.57143C14.9333 3.94286 14.4533 3.42857 13.8667 3.42857H12.8C12.2133 3.42857 11.7333 3.94286 11.7333 4.57143V11.4286C11.7333 12.0571 12.2133 12.5714 12.8 12.5714ZM14.9333 13.7143H1.06667C0.48 13.7143 0 14.2286 0 14.8571C0 15.4857 0.48 16 1.06667 16H14.9333C15.52 16 16 15.4857 16 14.8571C16 14.2286 15.52 13.7143 14.9333 13.7143ZM2.13333 12.5714H3.2C3.78667 12.5714 4.26667 12.0571 4.26667 11.4286V6.85714C4.26667 6.22857 3.78667 5.71429 3.2 5.71429H2.13333C1.54667 5.71429 1.06667 6.22857 1.06667 6.85714V11.4286C1.06667 12.0571 1.54667 12.5714 2.13333 12.5714Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default ReportIcon;
